import { render, staticRenderFns } from "./choice_echo.vue?vue&type=template&id=4841f784&scoped=true&"
import script from "./choice_echo.vue?vue&type=script&lang=js&"
export * from "./choice_echo.vue?vue&type=script&lang=js&"
import style0 from "./choice_echo.vue?vue&type=style&index=0&id=4841f784&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4841f784",
  null
  
)

export default component.exports